import { Injectable } from '@angular/core';
import { AccountService } from '../../../shared/services/account.service';
import { ShopifyService } from '../services/shopify.service';
import { Observable, of } from 'rxjs';
import { LogService } from '../../../shared/services/log.service';
import { YOTPO_SUPPORT_PATH } from '../navigation/constants';

@Injectable()
export class AccountResolver {

  constructor(
    private accountService: AccountService,
    private shopifyService: ShopifyService,
    private logger: LogService
  ) {}

  init() {
    let appData$ = this.accountService.getAppData();
    let platformAdminLinks$ = this.accountService.getPlatformAdminLinks().catch(error => {
      this.logger.error('error in account resolver - ' + JSON.stringify(error));
      return of({
        response: {
          platform_admin_links: {
            themes: YOTPO_SUPPORT_PATH,
            product_liquid: YOTPO_SUPPORT_PATH,
            theme_liquid: YOTPO_SUPPORT_PATH,
            checkout_edit_page: YOTPO_SUPPORT_PATH
          }
        }
      });

    });
    return Observable.forkJoin(appData$, platformAdminLinks$, (appData, platformAdminLinks) => {
      let platformLinks = platformAdminLinks.response ? {
          themes: platformAdminLinks.response.platform_admin_links.themes,
          productLiquid: platformAdminLinks.response.platform_admin_links.product_liquid,
          themeLiquid: platformAdminLinks.response.platform_admin_links.theme_liquid,
          checkoutEditPage: platformAdminLinks.response.platform_admin_links.checkout_edit_page
        } : { };
      return {
        account: {
          storeName: appData.response.app.customer_mails_sender_name,
          autoPublish: appData.response.app.auto_publish,
          platform: appData.response.app.account_platform.platform_type.name,
          secret: appData.response.app.secret,
          platformErrors: [],
          userEmail: appData.response.app.users[0].email,
          totalOrders: appData.response.app.data_for_events.total_orders,
        },
        platformLinks: platformLinks
      };
    }).mergeMap(accountData => {
        if (accountData.account.platform === 'shopify') {
          return this.shopifyService.checkAutoInstallPreconditions().mergeMap(errors => {
            accountData.account.platformErrors = errors;
            return of(accountData);
          }).catch((error) => {
            accountData.account.platformErrors = [error.message];
            return of(accountData);
            }
          );
        }
        return of(accountData);
    });
  }
}
